import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase config (copy from Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyCJnW4920QUvjwM6Luj4vMKviUNVCZay8I",
  authDomain: "virtualgift-5d51f.firebaseapp.com",
  projectId: "virtualgift-5d51f",
  storageBucket: "virtualgift-5d51f.firebasestorage.app",
  messagingSenderId: "330413336561",
  appId: "1:330413336561:web:88d3bffdc9dd6892a18650",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
